import { Component, Mixins, Prop } from 'vue-property-decorator'
import { HorizontalBar, mixins } from 'vue-chartjs'
import { IChartData } from '@/types'
const { reactiveProp } = mixins

@Component({
	mixins: [reactiveProp]
})

export default class HorizontalBarChart extends Mixins(HorizontalBar) {

	@Prop()
	private chartData!: IChartData;

	@Prop()
	private chartOptions!: any;
	
	mounted() {
		this.renderChart(this.chartData, this.chartOptions);
	}
}